import React, { PropTypes } from 'react';
import cx from 'classnames';
import s from './style';

function InputForm({ className, label, input, required, placeholder, meta: { touched, error } }) {
  const classes = cx(s.root, className, touched && error && s.error);
  return (
    <div className={classes}>
      <div className={s.label}>{label}{required && <sup>*</sup>}</div>
      <input
        placeholder={placeholder}
        {...input}
      />
      {touched && error && <span className={s.message}>{error}</span>}
    </div>
  );
}

export default InputForm;



// WEBPACK FOOTER //
// ./src/components/common/InputForm/InputForm.js